import { render, staticRenderFns } from "./OrderComplete.vue?vue&type=template&id=6e0853d8&"
import script from "./OrderComplete.vue?vue&type=script&lang=ts&"
export * from "./OrderComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports